import React from 'react';
import { Button } from 'react-bootstrap';
import { JsonView } from './JsonView';
import { Pagination } from 'react-bootstrap';
import ReactTable from 'react-table';

export class NaturalLanguageApi extends React.PureComponent {
    STORAGE_KEY = "nlp/content";

    ENTITY_COLUMNS = [
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: 'Type',
            accessor: 'type',
        },
        {
            Header: 'Mentions',
            accessor: 'mentions',
            Cell: row => <ul>{row.value.map((m, i) => <li key={i}>{m.text.content}: {m.type}</li>)}</ul>,
        },
        {
            Header: 'Salience',
            accessor: 'salience',
        },
        {
            Header: 'Metadata',
            accessor: 'metadata',
            Cell: row => JSON.stringify(row.value, null, 4),
        },
    ];
    ENTITY_SENTIMENT_COLUMNS = [
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: 'Type',
            accessor: 'type',
        },
        {
            Header: 'Mentions',
            accessor: 'mentions',
            Cell: row => <ul>{row.value.map((m, i) => <li key={i}>{m.text.content}: {m.type}</li>)}</ul>,
        },
        {
            Header: 'Salience',
            accessor: 'salience',
        },
        {
            Header: 'Metadata',
            accessor: 'metadata',
            Cell: row => JSON.stringify(row.value, null, 4),
        },
        {
            Header: 'Sentiment Magnitude',
            accessor: 'sentiment.magnitude'
        },
        {
            Header: 'Sentiment Score',
            accessor: 'sentiment.score'
        }
    ];
    SENTIMENT_COLUMNS = [
        {
            Header: "Text",
            accessor: 'text.content',
        },
        {
            Header: 'Sentiment Magnitude',
            accessor: 'sentiment.magnitude'
        },
        {
            Header: 'Sentiment Score',
            accessor: 'sentiment.score'
        }
    ];
    CLASSIFY_TEXT_COLUMNS = [
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: 'Confidence',
            accessor: 'confidence'
        }
    ];

    state = {
        content: window.localStorage.getItem(this.STORAGE_KEY) || '',
        mode: 6,
    };

    selectMode = mode => () => {
        this.setState({ mode });
    }

    refresh = name => async () => {
        const response = await fetch(`/api/data/nlp/${name}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                content: this.state.content
            })
        });
        const result = await response.json();
        this.setState({ [name]: result.result });
    }

    handleContent = e => {
        window.localStorage.setItem(this.STORAGE_KEY, e.target.value);
        this.setState({ content: e.target.value });
    }

    render() {
        return (
            <div>
                <textarea value={this.state.content} onChange={this.handleContent} rows={20} cols={140}></textarea>
                <Pagination>
                    <Pagination.Item key={6} active={this.state.mode === 6} onClick={this.selectMode(6)}>
                        Classify Text
                    </Pagination.Item>
                    <Pagination.Item key={3} active={this.state.mode === 3} onClick={this.selectMode(3)}>
                        Sentiment
                    </Pagination.Item>
                    <Pagination.Item key={2} active={this.state.mode === 2} onClick={this.selectMode(2)}>
                        Entity Sentiment
                    </Pagination.Item>
                </Pagination>
                {
                    this.state.mode == 1 &&
                    <div>
                        <Button onClick={this.refresh('entities')}>Refresh</Button>
                        {
                            this.state.entities &&
                            <ReactTable
                                data={this.state.entities.entities}
                                columns={this.ENTITY_COLUMNS}
                                pageSize={this.state.entities.entities.length}
                                showPagination={false}
                            />
                        }
                    </div>
                }
                {
                    this.state.mode == 2 &&
                    <div>
                        <Button onClick={this.refresh('entity_sentiment')}>Refresh</Button>
                        {
                            this.state.entity_sentiment &&
                            <ReactTable
                                data={this.state.entity_sentiment.entities}
                                columns={this.ENTITY_SENTIMENT_COLUMNS}
                                pageSize={this.state.entity_sentiment.entities.length}
                                showPagination={false}
                            />
                        }
                    </div>
                }
                {
                    this.state.mode == 3 &&
                    <div>
                        <Button onClick={this.refresh('sentiment')}>Refresh</Button>
                        {
                            this.state.sentiment &&
                            <div>
                                <ul>
                                    <h3>Document Sentiment</h3>
                                    <li>Magnitude: {this.state.sentiment.documentSentiment.magnitude}</li>
                                    <li>Score: {this.state.sentiment.documentSentiment.magnitude}</li>
                                </ul>
                                <ReactTable
                                    data={this.state.sentiment.sentences}
                                    columns={this.SENTIMENT_COLUMNS}
                                    pageSize={this.state.sentiment.sentences.length}
                                    showPagination={false}
                                />
                            </div>
                        }
                    </div>
                }
                {
                    this.state.mode == 4 &&
                    <div>
                        <Button onClick={this.refresh('syntax')}>Refresh</Button>
                        {
                            this.state.syntax &&
                            <div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.mode == 5 &&
                    <div>
                        <Button onClick={this.refresh('annotate_text')}>Refresh</Button>
                        {
                            this.state.annotate_text &&
                            <div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.mode == 6 &&
                    <div>
                        <Button onClick={this.refresh('classify_text')}>Refresh</Button>
                        {
                            this.state.classify_text &&
                            <ReactTable
                                data={this.state.classify_text.categories}
                                columns={this.CLASSIFY_TEXT_COLUMNS}
                                pageSize={this.state.classify_text.categories.length}
                                showPagination={false}
                            />
                        }
                    </div>
                }
            </div>
        );
    }
}
